
import * as React from 'react'
import { Text, View, ScrollView, Dimensions, TouchableOpacity, Image } from 'react-native'
import { useTheme } from '@react-navigation/native'
import {
    PieChart,
} from "react-native-chart-kit"
import numeral from 'numeral'
import _ from 'lodash'
import Axios from 'axios'
import { RefreshControl } from 'react-native-web-refresh-control'
import images from '../../assets/images'

export default React.memo(function SalesChannel({ month_string }) {
    const { colors } = useTheme()
    const [data, setData] = React.useState()
    const [data_summary, setDataSummary] = React.useState()
    const [refreshing, setRefreshing] = React.useState(true)
    const screenWidth = Dimensions.get("window").width;
    const chartConfig = {
        backgroundGradientFrom: "#1E2923",
        backgroundGradientFromOpacity: 0,
        backgroundGradientTo: "#08130D",
        backgroundGradientToOpacity: 0.5,
        color: (opacity = 1) => `rgba(26, 255, 146, ${opacity})`,
        strokeWidth: 2, // optional, default 3
        barPercentage: 0.5,
        useShadowColorFromDataset: false // optional
    };
    const arrColors = ['#B3E59F', '#FFBD86', '#3EA69B', '#FA6B6B', '#FFC100', '#A1A9C3', '#425486', '#DC8744', '#EAB0F3', '#91EBF1']

    React.useEffect(() => {
        setRefreshing(true)
        Axios.get(`api/ceo/customer/proportion-channel?day=${month_string}`)
            .then(res => {
                if (res.status === 200) {
                    const converseData = []
                    try {
                        res.data.channels.map((item, index) => {
                            const newItem = { ...item, legendFontSize: 14, name: item.name }
                            converseData.push(newItem)
                        })
                    } catch (error) {
                    }
                    setData(converseData)
                    setDataSummary(res.data)
                }
                setRefreshing(false)
            }).catch(err => {
                setRefreshing(false)
                console.log(err)
            })
    }, [month_string])

    const onRefresh = () => {
        setRefreshing(true)
        Axios.get(`api/ceo/customer/proportion-channel?day=${month_string}`)
            .then(res => {
                console.log(res)
                if (res.status === 200) {
                    const converseData = []
                    try {
                        res.data.channels.map((item, index) => {
                            const newItem = { ...item, color: arrColors[index], legendFontSize: 14, name: item.name }
                            converseData.push(newItem)
                        })
                    } catch (error) {
                    }
                    setData(converseData)
                    setDataSummary(res.data)
                }
                setRefreshing(false)
            }).catch(err => {
                setRefreshing(false)
                console.log(err)
            })
    }

    const renderWidthBarChart = (value, max) => {
        return ((value / max) * 100 + '%')
    }

    const renderBarChart = (item, index) => {

        const arrPoint = [item.count_ticket_plan, item.count_ticket, item.count_ticket_ago]
        const maxPoint = _.max(arrPoint);


        return <View key={index} style={{ paddingTop: 16 }}>
            <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold' }}>{item.name}</Text>
            <View style={{ paddingTop: 4, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                <View style={{ width: 48 }}>
                    <Text style={{ color: colors.text_sub, fontSize: 12, fontFamily: 'Nunito_700Bold' }}>{numeral(item.count_ticket).format('0,0')}</Text>
                </View>
                <View style={{ height: 10, flex: 1 }}>
                    <View style={{ height: '100%', borderRadius: 2, width: renderWidthBarChart(item.count_ticket, maxPoint), backgroundColor: colors.bg_blue, }} />
                </View>
            </View>
            <View style={{ paddingTop: 4, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                <View style={{ width: 48 }}>
                    <Text style={{ color: colors.text_sub, fontSize: 12, fontFamily: 'Nunito_700Bold' }}>{numeral(item.count_ticket_plan).format('0,0')}</Text>
                </View>
                <View style={{ height: 10, flex: 1 }}>
                    <View style={{ height: '100%', borderRadius: 2, width: renderWidthBarChart(item.count_ticket_plan, maxPoint), backgroundColor: colors.bg_orange }} />
                </View>
            </View>
            <View style={{ paddingTop: 4, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                <View style={{ width: 48 }}>
                    <Text style={{ color: colors.text_sub, fontSize: 12, fontFamily: 'Nunito_700Bold' }}>{numeral(item.count_ticket_ago).format('0,0')}</Text>
                </View>
                <View style={{ height: 10, flex: 1 }}>
                    <View style={{ height: '100%', borderRadius: 2, width: renderWidthBarChart(item.count_ticket_ago, maxPoint), backgroundColor: colors.bg_green }} />
                </View>
            </View>

        </View>
    }

    const getColorProgress = (value) => {
        try {
            if (value < 50) return colors.process_3
            else if (value < 75) return colors.process_1
            else return colors.process_2
        } catch (error) {
        }
    }

    const renderNoteBarChart = (color, title, index, value) => {
        return (<View key={index} style={{ alignContent: 'center', alignItems: 'center', flexDirection: 'row', paddingVertical: 2 }}>
            <View style={{ width: 12, height: 12, borderRadius: 6, backgroundColor: color, paddingRight: 6 }} />
            <Text style={{ color: colors.text, fontSize: 12, paddingHorizontal: 6, fontFamily: 'Nunito_700Bold' }} numberOfLines={1}>({value}%) {title} </Text>
        </View>)
    }

    return (
        <ScrollView style={{ flex: 1 }} refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} tintColor={colors.text} colors={[colors.text]} />}>
            {
                data && data_summary ? <>
                    <View style={{ backgroundColor: 'white', marginHorizontal: 12, marginTop: 18, borderRadius: 10, paddingHorizontal: 15 }}>
                        <View style={{ marginTop: 8, flexDirection: 'column', alignItems: 'center' }}>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 15, color: colors.text }}>TỔNG SỐ VÉ</Text>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 32, color: colors.text }}>{data_summary?.count_ticket_total?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 15, color: colors.text_sub }}>{data_summary?.average.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} vé / ngày</Text>
                        </View>
                        <View style={{ flexDirection: 'row', marginBottom: 16, marginTop: 12 }}>
                            <View style={{
                                height: 28, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                justifyContent: 'center'
                            }}>
                                <View style={{
                                    position: 'absolute', top: 0, left: 0, width: `${data_summary?.ratio_ticket_total_plan > 100 ? 100 : data_summary?.ratio_ticket_total_plan}%`,
                                    height: '100%', backgroundColor: getColorProgress(data_summary?.ratio_ticket_total_plan), borderRadius: 3
                                }} />
                                <View style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', justifyContent: 'center' }}>
                                    <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', paddingHorizontal: 6 }}>{data_summary?.ratio_ticket_total_plan}% kế hoạch</Text>
                                </View>
                            </View>
                        </View>
                    </View>

                    <View style={{
                        backgroundColor: 'white', marginHorizontal: 12, marginTop: 18, borderRadius: 10, paddingHorizontal: 15, flexDirection: 'row',
                        justifyContent: 'center', alignItems: 'center'
                    }}>
                        <View style={{ flex: 1 }}>
                            <PieChart
                                data={data}
                                width={160}
                                height={160}
                                chartConfig={chartConfig}
                                accessor={"ratio"}
                                backgroundColor={"transparent"}
                                paddingLeft={"24"}
                                hasLegend={false}
                                center={[10, 0]}
                                avoidFalseZero={true}
                            />
                        </View>
                        <View style={{ padding: 10, flex: 1 }}>
                            {
                                data && data.map((item, index) => {
                                    return renderNoteBarChart(item.color, item.name, index, item.ratio)
                                })
                            }
                        </View>
                    </View>
                    <View style={{ backgroundColor: 'white', marginHorizontal: 12, marginTop: 18, borderRadius: 10, paddingVertical: 8, paddingHorizontal: 15 }}>
                        <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                            <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                <View style={{ width: 10, height: 10, borderRadius: 5, backgroundColor: colors.bg_orange }} />
                                <Text style={{ color: colors.text_sub, paddingHorizontal: 6, fontSize: 12, fontFamily: 'Nunito_700Bold' }}>BQ ngày kế hoạch</Text>
                            </View>

                            <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                <View style={{ width: 10, height: 10, borderRadius: 5, backgroundColor: colors.bg_blue }} />
                                <Text style={{ color: colors.text_sub, paddingHorizontal: 6, fontSize: 12, fontFamily: 'Nunito_700Bold' }}>BQ ngày tháng này</Text>
                            </View>
                        </View>

                        <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingTop: 8 }}>
                            <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                <View style={{ width: 10, height: 10, borderRadius: 5, backgroundColor: colors.bg_green }} />
                                <Text style={{ color: colors.text_sub, paddingHorizontal: 6, fontSize: 12, fontFamily: 'Nunito_700Bold' }}>BQ ngày tháng trước</Text>
                            </View>
                        </View>
                        {
                            data.map((item, index) => renderBarChart(item, index))
                        }

                    </View>
                    <View style={{ marginBottom: 16 }} />
                </> : (
                        !refreshing ? <View style={{ marginTop: 80, flexDirection: 'column', alignItems: 'center' }}>
                            <Image source={images.server_error} style={{ width: 200, height: 200 }} />
                            <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', marginTop: 24, fontSize: 18 }}>Đã có lỗi xảy ra</Text>
                            <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 18 }}>Vui lòng ấn nút bên dưới để thử lại</Text>
                            <TouchableOpacity onPress={onRefresh}>
                                <Image source={images.refresh} style={{ width: 40, height: 40, marginTop: 16 }} />
                            </TouchableOpacity>
                        </View> : null
                    )
            }
        </ScrollView>
    )
})